import api from './config';
import { initializeFirebaseMessaging } from '../utils/firebase';

export const login = async (email, password) => {
    try {
        const response = await api.post('/auth/login', {
            email,
            password
        });

        const data = response.data;

        if (data.jwt == null) {
            throw Error("Cannot login at the moment");
        }

        localStorage.setItem('token', btoa(data.jwt)); // Base64 encode the JWT for now
        localStorage.setItem('timezone', data.timezone);
        
        // Initialize Firebase messaging after successful login
        try {
            await initializeFirebaseMessaging();
        } catch (firebaseError) {
            console.error('Failed to initialize Firebase messaging:', firebaseError);
            // Continue even if Firebase messaging fails
        }
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const logout = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.post('/auth/logout', {}, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        localStorage.removeItem('token');
        localStorage.removeItem('timezone');
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const signup = async (name, email, password) => {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await api.post('/auth/signup', {
            email,
            name,
            password,
            timezone
        });

        const data = response.data;

        if (data.jwt == null) {
            throw Error("Cannot signup at the moment");
        }

        localStorage.setItem('token', btoa(data.jwt)); // Base64 encode the JWT for now
        localStorage.setItem('timezone', data.timezone);
        
        // Initialize Firebase messaging after successful signup
        try {
            await initializeFirebaseMessaging();
        } catch (firebaseError) {
            console.error('Failed to initialize Firebase messaging:', firebaseError);
            // Continue even if Firebase messaging fails
        }
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const forgotPassword = async (email) => {
    try {
        await api.post('/auth/forgot-password', { email });
        // No need to handle response data as it's a void endpoint
        // Success will be indicated by no error being thrown
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const resetPassword = async (token, password) => {
    try {
        await api.post('/auth/reset-password', {
            token,
            password
        });
        // No need to handle response data as it's a void endpoint
        // Success will be indicated by no error being thrown
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const authenticateWithGoogle = async (idToken) => {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await api.post('/auth/google', {
            idToken,
            timezone
        });

        const data = response.data;

        if (data.jwt == null) {
            throw Error("Cannot login at the moment");
        }

        localStorage.setItem('token', btoa(data.jwt));
        localStorage.setItem('timezone', data.timezone);
        
        // Initialize Firebase messaging after successful Google login
        try {
            await initializeFirebaseMessaging();
        } catch (firebaseError) {
            console.error('Failed to initialize Firebase messaging:', firebaseError);
            // Continue even if Firebase messaging fails
        }
    } catch (error) {
        throw error.message || 'Failed to authenticate with Google';
    }
};